(function () {
    const skuDataEl = document.querySelector('script[data-variants-sku-json]');
    if (!skuDataEl) return;

    const skuContainer     = document.getElementById('active_product_sku_value');
    const distSkuContainer = document.getElementById('active_product_dist_sku_value');
    const distSkuWrapper   = document.getElementById('active_product_dist_sku');

    const getVariants = () => {
        try {
            return JSON.parse(skuDataEl.textContent);
        } catch (e) {
            console.error("Failed to parse variant SKU JSON:", e);
            return [];
        }
    };

    const getVariantIdFromUrl = () => {
        return new URLSearchParams(window.location.search).get("variant");
    };

    const updateSkuFromUrl = () => {
        const variantId = getVariantIdFromUrl();
        const variant   = getVariants().find(v => String(v.id) === variantId);
        if (!variant) return;

        if (skuContainer && variant.sku) {
            skuContainer.textContent = variant.sku;
        }

        if (distSkuWrapper) {
            if (variant.distributor_sku) {
                if (distSkuContainer) distSkuContainer.textContent = variant.distributor_sku;
                distSkuWrapper.style.display = '';
            } else {
                distSkuWrapper.style.display = 'none';
            }
        }
    };

    // Watch for Shopify's pushState/replaceState URL variant changes
    const wrapHistoryMethod = (type) => {
        const original = history[type];
        history[type] = function () {
            const result = original.apply(this, arguments);
            updateSkuFromUrl();
            return result;
        };
    };

    ['pushState', 'replaceState'].forEach(wrapHistoryMethod);
    window.addEventListener('popstate', updateSkuFromUrl);
})();
